// Exotics widgets share PricingProvider (architect E8). Thin pass-through.
import type { FC } from 'react';

import ExoticsModelBandWidget from './exotics-model-band-widget';
import type { ExoticsModelBandProps } from './types';

const ExoticsModelBandWrapperProvider: FC<ExoticsModelBandProps> = (props) => (
  <ExoticsModelBandWidget {...props} />
);

export default ExoticsModelBandWrapperProvider;
